import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

const LOGO_BLACK = "https://customer-assets.emergentagent.com/job_9bee4b07-8d72-479e-a1c0-b19de3e7f530/artifacts/13f66ozi_biro_logo_black-350x100.png";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            await login(email, password);
            navigate("/admin/dashboard");
        } catch (err) {
            const detail = err.response?.data?.detail;
            setError(typeof detail === "string" ? detail : "Inloggningen misslyckades");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F5F5F5] flex items-center justify-center px-6" data-testid="admin-login-page">
            <div className="w-full max-w-sm">
                <div className="text-center mb-8">
                    <img src={LOGO_BLACK} alt="Birò" className="h-6 mx-auto mb-4" />
                    <p className="text-xs uppercase tracking-[0.15em] text-neutral-500">Admin</p>
                </div>
                <form onSubmit={handleSubmit} className="bg-white border border-neutral-200 p-6 rounded-md space-y-4">
                    {error && <div data-testid="login-error" className="p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-md">{error}</div>}
                    <div>
                        <label className="text-xs uppercase tracking-[0.15em] text-neutral-500 block mb-1.5">E-post</label>
                        <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@biro.se" required />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-[0.15em] text-neutral-500 block mb-1.5">Lösenord</label>
                        <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Lösenord" required />
                    </div>
                    <Button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full bg-black text-white hover:bg-neutral-800">
                        {loading ? <Loader2 size={16} className="animate-spin mr-2" /> : null}
                        {loading ? "Loggar in..." : "Logga in"}
                    </Button>
                </form>
            </div>
        </div>
    );
}
